import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useTranslator } from '@/hooks/useTranslator';
import { runWhenReady } from '@/utility/runWhenReady';

interface Props {
  readonly formName?: string;
}

export const VerifyBusinessHeader: React.FC<Props> = (props: Props): React.ReactElement => {
  const { formName } = props;
  const navigate = useNavigate();
  const tr = useTranslator();

  const saveAndClose = React.useCallback((): void => {
    navigate('/dashboard');
  }, [navigate]);

  const onSaveAndClose = React.useCallback((): void => {
    // This is just so that we ensure the onSubmit handler is called first
    runWhenReady(saveAndClose);
  }, [saveAndClose]);

  return (
    <Box sx={styles.headerContainer}>
      <Box sx={styles.headerContent}>
        <Typography variant="h6">{tr('VERIFY_YOUR_BUSINESS')}</Typography>
        <Button variant="dark" form={formName} onClick={onSaveAndClose}>
          {tr('SAVE_AND_CLOSE')}
        </Button>
      </Box>
    </Box>
  );
};

const styles: Record<string, SystemStyleObject> = {
  headerContainer: {
    gridColumn: '1 / span 4',
    backgroundColor: 'custom.OffWhite',
    alignSelf: 'start',
    position: 'sticky',
    top: 0,
    width: '100%',
    height: 104,
    flexShrink: 0,
    boxShadow: '0px 4px 12px 0px #00000005',
    // WTF?
    zIndex: 2,
  },
  headerContent: {
    display: 'flex',
    alignItems: 'center',
    width: 1125,
    height: '100%',
    justifyContent: 'space-between',
    margin: 'auto',
  },
};
